module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-ranger-picker"
  }, [_c('v-md-date-range-picker', {
    attrs: {
      "show-activator-label": false,
      "start-date": _vm.startDate,
      "end-date": _vm.endDate,
      "showYearSelect": true
    },
    on: {
      "change": _vm.rangeSelected
    }
  }, [_c('input', {
    attrs: {
      "slot": "input",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.textLabel
    },
    slot: "input"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4bc47a4c!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/RangePicker.vue
// module id = 2471
// module chunks = 1